module.exports = __webpack_public_path__ + "static/img/pause.0e2549a0.png";